module.exports = __webpack_public_path__ + "static/media/clipboard-white.03633177.svg";